module.exports = __webpack_public_path__ + "static/media/ultimate_party_pack_english_128.682d8670.png";